export function Input({ children }: any) {
  return (
    <div className="flex flex-col justify-between p-1 my-1 text-black dark:text-white">
      {children}
    </div>
  );
}
